import React from 'react';
import { Text } from '@fiverr-private/typography';
import { Container, Stack } from '@fiverr-private/layout_components';
import { useBriefCreationContext } from '../../../context/BriefCreationContext';

export interface NeedTypeOptionProps {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
}

export const NeedTypeOption: React.FC<NeedTypeOptionProps> = ({ icon, title, subtitle }) => {
  const { enableEnhancedUx } = useBriefCreationContext();

  return (
    <Stack
      direction={{ default: 'column', lg: enableEnhancedUx ? 'row' : 'column' }}
      gap="3"
      alignItems="flexStart"
      userSelect="none"
    >
      <Container>{icon}</Container>
      <Stack direction="column" gap="1">
        <Text size="b_md" fontWeight="semibold">
          {title}
        </Text>
        <Text size="b_md" color="bodySecondary">
          {subtitle}
        </Text>
      </Stack>
    </Stack>
  );
};
